function ProgramCode () {
    this.instructions = []
    this.inspections = {
        '_': []
    }
    this.currentContext = '_'
    this.CODE = {
        // Subroutine context
        START: 101,
        END: 102,

        // Memory Manipulation
        LDCONS: 201,
        PUSH: 202,
        POP: 203,
        ALLOCA: 204,
        ARRCPY: 205,
        FREEA: 206,
        LDREF: 207,
        LDREFA: 208,

        // Load & Store
        STORE: 301,
        STOREA: 302,
        STOREI: 303,
        LOAD: 304,
        LOADA: 305,
        LOADI: 306,

        // Operators And Functions
        OR: 401,
        AND: 402,
        EQ: 403,
        NEQ: 404,
        NOT: 405,
        LT: 406,
        LTE: 407,
        GT: 408,
        GTE: 409,
        SUM: 410,
        SUB: 411,
        MUL: 412,
        DIV: 413,
        POW: 414,
        MOD: 415,
        ABS: 416,
        SQRT: 417,

        // IO Functions
        WRITE: 501,
        READ: 502,

        // Branching
        JUMP: 601,
        BRANCH: 602,
        CCMP: 603,
        CALL: 604,
        RETURN: 605,

        // Misc
        WTIME: 701,
        CSCR: 703,
        WKEY: 704
    }
    this.inverse = {}
    for (let i in this.CODE) {
        this.inverse[this.CODE[i]] = i
    }
}

ProgramCode.prototype = {
    get (index) {
        return this.instructions[index]
    },
    addInspection (context, id, expression, program) {
        this.inspections[this.currentContext].push({
            context,
            id,
            expression,
            program
        })
    },
    getInspections (index) {
        if (index >= 0 && index < this.instructions.length && this.inspections[this.instructions[index].context] !== undefined) {
            return this.inspections[this.instructions[index].context]
        }

        console.log('getInspections invalid index ', index)
        return []
    },
    instructionCount () {
        return this.instructions.length - 1
    },
    hasInspections () {
        return Object.keys(this.inspections).length > 0
    },
    setCurrentContext (newContext) {
        this.currentContext = newContext
    },
    getCurrentContext () {
        return this.currentContext
    },
    setToken (instruction, token) {
        instruction.debug.fromLine = token.line
        instruction.debug.fromColumn = token.column
        instruction.debug.toLine = token.line
        instruction.debug.toColumn = token.column + token.lexema.length
        instruction.debug.ident = token.lexema
        instruction.debug.procName = token.procName
    },
    _insert (instruction, op1, op2, fromLine, fromColumn, toLine, toColumn, ident, procName) {
        const item = {
            instruction,
            op1,
            op2,
            debug: {
                fromLine,
                fromColumn,
                toLine,
                toColumn,
                ident,
                procName
            },
            context: this.currentContext
        }

        this.instructions.push(item)

        return item
    },
    _insertToken (instruction, op1, op2, token) {
        if (token) {
            return this._insert(instruction, op1, op2, token.line, token.column, token.line, token.column + token.lexema.length, token.lexema, token.procName)
        } else {
            return this._insert(instruction, op1, op2, null, null, null, null, null, null)
        }
    },
    copyFrom (pcode) {
        for (let ins of pcode.instructions) {
            this.instructions.push(ins)
        }
    },
    _dump () {
        for (let i = 0; i < this.instructions.length; i++) {
            console.log(i + ' ' + this.insToString(this.instructions[i]))
        }
        if (this.inspections.length > 0) {
            console.log('-------------------inspections-------------------')
            for (let i in this.inspections) {
                if (this.inspections[i].length > 0) {
                    console.log('START inspections for context ', i)
                    for (let j in this.inspections[i]) {
                        this.inspections[i][j]._dump()
                    }
                    console.log('END inspections for context ', i)
                }
            }
        }
    },
    insToString (ins) {
        let str = this.inverse[ins.instruction] + '\t'
        if (ins.op1 !== null) {
            if (typeof ins.op1 === 'string') {
                str += JSON.stringify(ins.op1.substr(0, 5)) + '\t'
            } else {
                str += ins.op1 + '\t'
            }
        } else {
            str += '\t'
        }
        if (ins.op2 !== null) {
            if (typeof ins.op2 === 'string') {
                str += JSON.stringify(ins.op2.substr(0, 5)) + '\t'
            } else {
                str += ins.op2 + '\t'
            }
        } else {
            str += '\t'
        }
        str += '\t(' + ins.debug.fromLine + ':' + ins.debug.fromColumn + ')'
        if (ins.debug.ident !== null) {
            str += ' // ' + JSON.stringify(ins.debug.ident) + ' '
        }
        str += '\t/' + ins.context + '/'
        return str
    },

    /* Subroutine Context */
    start (token) {
        this.currentContext = token.procName
        this.inspections[this.currentContext] = []
        this._insertToken(this.CODE.START, null, null, token)
    },
    end (token) {
        this._insertToken(this.CODE.END, null, null, token)
        this.currentContext = '_'
    },

    /* Memory Manipulation */
    ldcons (type, value, token) {
        this._insertToken(this.CODE.LDCONS, type, value, token)
    },
    push (type, count, token) {
        this._insertToken(this.CODE.PUSH, type, count, token)
    },
    pop (type, count, token) {
        this._insertToken(this.CODE.POP, type, count, token)
    },
    alloca (type, count, token) {
        this._insertToken(this.CODE.ALLOCA, type, count, token)
    },
    arrcpy (type, displ, token) {
        this._insertToken(this.CODE.ARRCPY, type, displ, token)
    },
    freea (type, token) {
        this._insertToken(this.CODE.FREEA, type, null, token)
    },
    ldref (type, displ, token) {
        this._insertToken(this.CODE.LDREF, type, displ, token)
    },
    ldrefa (type, displ, token) {
        this._insertToken(this.CODE.LDREFA, type, displ, token)
    },

    /* Load & Store */
    store (type, displ, token) {
        this._insertToken(this.CODE.STORE, type, displ, token)
    },
    storea (type, displ, token) {
        this._insertToken(this.CODE.STOREA, type, displ, token)
    },
    storei (type, displ, token) {
        this._insertToken(this.CODE.STOREI, type, displ, token)
    },
    load (type, displ, token) {
        this._insertToken(this.CODE.LOAD, type, displ, token)
    },
    loada (type, displ, token) {
        this._insertToken(this.CODE.LOADA, type, displ, token)
    },
    loadi (type, displ, token) {
        this._insertToken(this.CODE.LOADI, type, displ, token)
    },

    /* Operators And Functions */
    or (token) {
        this._insertToken(this.CODE.OR, null, null, token)
    },
    and (token) {
        this._insertToken(this.CODE.AND, null, null, token)
    },
    eq (token) {
        this._insertToken(this.CODE.EQ, null, null, token)
    },
    neq (token) {
        this._insertToken(this.CODE.NEQ, null, null, token)
    },
    not (token) {
        this._insertToken(this.CODE.NOT, null, null, token)
    },
    lt (token) {
        this._insertToken(this.CODE.LT, null, null, token)
    },
    lte (token) {
        this._insertToken(this.CODE.LTE, null, null, token)
    },
    gt (token) {
        this._insertToken(this.CODE.GT, null, null, token)
    },
    gte (token) {
        this._insertToken(this.CODE.GTE, null, null, token)
    },
    sum (token) {
        this._insertToken(this.CODE.SUM, null, null, token)
    },
    sub (token) {
        this._insertToken(this.CODE.SUB, null, null, token)
    },
    mul (token) {
        this._insertToken(this.CODE.MUL, null, null, token)
    },
    div (token) {
        this._insertToken(this.CODE.DIV, null, null, token)
    },
    pow (token) {
        this._insertToken(this.CODE.POW, null, null, token)
    },
    mod (token) {
        this._insertToken(this.CODE.MOD, null, null, token)
    },
    abs (token) {
        this._insertToken(this.CODE.ABS, null, null, token)
    },
    sqrt (token) {
        this._insertToken(this.CODE.SQRT, null, null, token)
    },

    /* IO Functions */
    write (token) {
        this._insertToken(this.CODE.WRITE, null, null, token)
    },
    read (type, token) {
        this._insertToken(this.CODE.READ, type, null, token)
    },

    /* Branching */
    jump (displ, token) {
        return this._insertToken(this.CODE.JUMP, displ, null, token)
    },
    branch (displ, token) {
        return this._insertToken(this.CODE.BRANCH, displ, null, token)
    },
    ccmp (token) {
        this._insertToken(this.CODE.CCMP, null, null, token)
    },
    call (displ, token) {
        this._insertToken(this.CODE.CALL, displ, null, token)
    },
    return (token) {
        this._insertToken(this.CODE.RETURN, null, null, token)
        this.currentContext = '_'
    },

    /* Misc */
    clearScreen (token) {
        this._insertToken(this.CODE.CSCR, null, null, token)
    },
    waitTime (token) {
        this._insertToken(this.CODE.WTIME, null, null, token)
    },
    waitKey (token) {
        this._insertToken(this.CODE.WKEY, null, null, token)
    }
}

export default ProgramCode



// WEBPACK FOOTER //
// ./src/Core/Parser/ProgramCode.js